import { makeStyles } from '@mui/styles';
import { useTheme } from '@mui/material';

const styles = makeStyles(() => ({
	Box: {
		// marginTop: useTheme().spacing(2),
		// marginBottom: useTheme().spacing(12),
	},
	containerRoot: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
	},
	textInputContainer: {
		position: 'relative',
		display: 'flex',
		alignItems: 'center',
		width: '100%',
	},
	IconContainer: {
		position: 'absolute',
		right: 0,
		top: 10,
		bottom: 0,
		display: 'flex',
	},
	[useTheme().breakpoints.down('sm')]: {
		headingText: {
			paddingTop: useTheme().spacing(4),
			paddingBottom: useTheme().spacing(4),
		},
	},
	[useTheme().breakpoints.up('md')]: {
		headingText: {
			paddingTop: 30,
			paddingBottom: 30,
		},
	},
	GridContainer: {
		paddingLeft: useTheme().spacing(2),
		paddingRight: useTheme().spacing(2),
		paddingTop: useTheme().spacing(1),
	},
}));
export default styles;
